import { render } from "./TrainConfigsAndModels.vue?vue&type=template&id=32fc3046"
import script from "./TrainConfigsAndModels.vue?vue&type=script&lang=js"
export * from "./TrainConfigsAndModels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__